import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MtcTypeModel } from './mtcType.model'
import { MtcTypeService } from './mtcType.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-mtctype.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './mtcType.master.component.html',
  styleUrl: './mtcType.master.component.css',
})
export class MtcTypeMasterComponent implements OnInit {
  mtctypeColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'mtcType',
      displayName: 'Mtc Type Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private mtctypeService: MtcTypeService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {
    this.getAllItems()
  }

  ngOnInit(): void {}

  getAllItems(): void {
    this.mtctypeService.getAllMtcTypes().subscribe({
      next: (data: any) => {
        this.masterCommonService.mtcTypesList = data
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  openAddUpdateMtcTypeDialog(mode: string, mtctype?: MtcTypeModel): void {
    const fields = this.mtctypeColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: mtctype || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateMtcType(result)
        } else {
          this.addMtcType(result)
        }
      }
    })
  }

  addMtcType(mtctype: any): void {
    this.mtctypeService.addMtcType(mtctype).subscribe({
      next: () => {
        this.toastr.success('Mtc Type Added Successfully!', 'Success')
        this.getAllItems()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateMtcType(mtctype: any): void {
    this.mtctypeService.updateMtcType(mtctype).subscribe({
      next: () => {
        this.toastr.success('Mtc Type Updated Successfully!', 'Success')
        this.getAllItems()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteMtcType(mtctype: MtcTypeModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this mtc type?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        mtctype.isDeleted = true
        this.mtctypeService.deleteMtcType(mtctype).subscribe({
          next: () => {
            this.masterCommonService.mtcTypesList = this.masterCommonService.mtcTypesList.filter(
              (p) => p.id !== mtctype.id,
            )
            this.toastr.success('Mtc Type Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
